import { SidebarSectionItemProps } from '.';

// This object should contain a mock value for each required prop of this component
export const requiredProps: SidebarSectionItemProps = {};

// This array should contain an object only for tests you wish to run on all compliance tests
const sharedTests = [
  {
    title: 'render',
    props: {
      ...requiredProps,
    } as SidebarSectionItemProps,
  },
];

export const testkitTests = [
  {
    title: 'render',
    props: {
      ...requiredProps,
      children: 'test',
    } as SidebarSectionItemProps,
  },
];

export const ssrTests = [...sharedTests];

export const a11yTests = [...sharedTests];
